import Popup from 'reactjs-popup';
import "./term-of-use.css"
import 'reactjs-popup/dist/index.css';
import TERM_OF_USE from '../../static/term-of-use'

const TermOfUsePopup = ({triggerElement}) => {

    return (
        <Popup
            trigger={triggerElement()} 
            position="right center" modal nested className='term-popup'>
            {close => {
                return (
                    <div id="term-container">

                        <h3 id='modal-header'>Term of Usage</h3>    

                        <button className="close" onClick={() => {close()}}>
                                &times;
                        </button>

                        {TERM_OF_USE}
    
                        <div className="actions">
                            <button id="close-button" onClick={() => {close()}}>Close</button>
                        </div>
                    </div>
                )
            }}
        </Popup>
    )
}

export default TermOfUsePopup;